import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsSchedulingRoute: InvariantJiraRoute = {
	name: 'plan-settings-scheduling',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling',
};
